import { useQuery } from 'react-query';
import { AxiosResponse } from 'axios';
import { useTranslation } from 'react-i18next';

import { useApiContext } from 'context/ApiContext';
import { KEYS } from 'helpers/react-query.config';
import { useGlobalContext } from 'context/GlobalContext';

const useGetAllServiceTypes = () => {
  const { showApiError, showApiAlert } = useGlobalContext();
  const { catalog: CatalogueApi } = useApiContext();
  const { t } = useTranslation('global');

  const { data, isLoading } = useQuery(
    [KEYS.catalog.serviceTypes.list()],
    () => CatalogueApi.serviceTypes.list(),
    {
      select: (response) => response?.data?.data,
      onError: (error: AxiosResponse) =>
        error?.request?.status === 500
          ? showApiError(error, t('errorMessages.partners'))
          : showApiAlert(error, t('errorMessages.partners')),
      refetchOnWindowFocus: false
    }
  );

  return {
    allServiceTypes: data,
    isAllServiceTypesLoading: isLoading
  };
};

export default useGetAllServiceTypes;
